import React from "react";
import { connect } from "react-redux";
import language from "../../../language";
import bloodDonationQuery from "../../../utils/queries/bloodDonationQuery";
import moment from "moment";

class CollectionPreview extends React.Component {
  state = {
    isLoading: false,
    donation: null,
  };

  componentDidMount = async () => {
    await this.getDonationPreview();
  };

  getDonationPreview = async () => {
    try {
      const { donationId, defaultLanguage } = this.props;
      if (!donationId) return;

      this.setState({ isLoading: true });

      const response = await bloodDonationQuery(defaultLanguage, {
        id: donationId,
        page: 1,
        limit: 1,
      });

      const donation = response?.data?.[0] || null;
      this.setState({ donation, isLoading: false });
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  renderField = (label, value) => (
    <div style={{ marginBottom: 10 }}>
      <div style={{ fontSize: 12, opacity: 0.7 }}>{label}</div>
      <div style={{ fontWeight: 600 }}>{value || "-"}</div>
    </div>
  );

  renderSection = (title, children) => (
    <div
      style={{
        border: "1px solid #e9ecef",
        borderRadius: 8,
        padding: 14,
        marginBottom: 14,
        backgroundColor: "#fff",
      }}
    >
      <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 10 }}>
        {title}
      </div>
      {children}
    </div>
  );

  render() {
    const { defaultLanguage } = this.props;
    const { isLoading, donation } = this.state;
    const t = language[defaultLanguage] || language.english;

    if (isLoading) {
      return <div className="card-body">{t.loading || "Loading..."}</div>;
    }

    if (!donation) {
      return <div className="card-body">{t.no_data_found || t.no_data}</div>;
    }

    return (
      <div className="card-body">
        <div className="row">
          <div className="col-md-6">
            {this.renderSection(t.donation_information, (
              <>
                {this.renderField(
                  t.donation_number,
                  donation?.donationNumber,
                )}
                {this.renderField(
                  t.status,
                  donation?.status,
                )}
                {this.renderField(
                  t.blood_group,
                  donation?.bloodInfo?.bloodGroup,
                )}
                {this.renderField(
                  t.volume,
                  donation?.bloodInfo?.volume,
                )}
                {this.renderField(
                  t.tested,
                  donation?.bloodInfo?.tested === true ? t.yes : t.no,
                )}
              </>
            ))}
          </div>
          <div className="col-md-6">
            {this.renderSection(`${t.donor_information} & ${t.center_site}`, (
              <>
                {this.renderField(
                  t.donor,
                  `${donation?.donor?.donorNumber || "-"}${
                    donation?.donor?.firstName
                      ? ` - ${donation?.donor?.firstName || ""} ${
                          donation?.donor?.lastName || ""
                        }`
                      : ""
                  }`,
                )}
                {this.renderField(
                  t.center,
                  donation?.center?.name,
                )}
                {this.renderField(
                  t.center_site,
                  donation?.centerSite?.name,
                )}
                {this.renderField(
                  t.collection_type,
                  donation?.collectionType?.name,
                )}
                {this.renderField(
                  t.collection_date,
                  donation?.collectionDate
                    ? moment(donation.collectionDate).format("lll")
                    : "-",
                )}
              </>
            ))}
          </div>
          <div className="col-md-6">
            {this.renderSection(t.collections, (
              <>
                {this.renderField(
                  t.start_time,
                  donation?.startTime,
                )}
                {this.renderField(
                  t.end_time,
                  donation?.endTime,
                )}
                {this.renderField(
                  t.equipment_code,
                  donation?.equipment?.code,
                )}
                {this.renderField(
                  t.equipment_name,
                  donation?.equipment?.name,
                )}
                {this.renderField(
                  t.cooler_box,
                  donation?.coolerBox?.code,
                )}
              </>
            ))}
          </div>
          <div className="col-md-6">
            {this.renderSection(t.blood_donation_tracking, (
              <>
                {this.renderField(
                  t.phlebotomist,
                  donation?.phlebotomist?.email ||
                    donation?.phlebotomist?.pin ||
                    "-",
                )}
                {this.renderField(
                  t.recorded_by,
                  donation?.addedBy?.name || donation?.addedBy?.email,
                )}
                {this.renderField(
                  t.blood_donation_recorder,
                  donation?.bloodRecorder?.pin,
                )}
                {this.renderField(
                  t.reaction,
                  donation?.reaction?.isReaction ? t.yes : t.no,
                )}
                {this.renderField(
                  t.reaction_category,
                  donation?.reaction?.category,
                )}
                {this.renderField(
                  t.reaction_comment,
                  donation?.reaction?.comment,
                )}
                {this.renderField(
                  t.created_at,
                  donation?.createdAt
                    ? moment(donation.createdAt).format("lll")
                    : "-",
                )}
              </>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(CollectionPreview);
